import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class LifecycleService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getOne(entityType, entityId) {
        try {
            const response = await withRetry(
                () => this.api.getOne(entityType, entityId),
                { maxRetries: 2 },
            );
            return {
                success: response.success !== false,
                data: response.data,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to resolve lifecycle');
        }
    }

    async bulk(items) {
        try {
            const response = await withRetry(
                () => this.api.bulk(items),
                { maxRetries: 2 },
            );
            return {
                success: response.success !== false,
                data: response.data,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to resolve lifecycle bulk');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
